import React, {useEffect, useState, useRef} from 'react';
import styles from "../../assets/stylesheets/sass/Navigation.module.scss";
import arrow from "../../assets/icons/arrow.svg";
import logo_wide from "../../assets/images/logo_wide.svg";
import Button from "../customComponents/Button";
import arrow_white from "../../assets/icons/backarrow_icon_white.svg";
import arrow_gray from "../../assets/icons/backarrow_icon_gray.svg";

import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom"

import Dropdownlist from '../customComponents/Dropdownlist';

import { ReactSession }  from 'react-client-session';
// import Qastan from "@qastanfit/logger"
export default function Navigation({navigationData, userRole, selectedPage, loggedOut, language, changeLanguage}) {

    const [lang_updater, setlang_updater] = useState("");
    const handleChangeLanguage = (lang) =>{
		setlang_updater(lang);
		ReactSession.set("language", lang);
        changeLanguage(lang);
	}

    useEffect(()=>{
		setlang_updater(language);
		ReactSession.set("language", language);
        changeLanguage(language);
	}, [language])

    useEffect(()=>{
        let cancel = false;

        fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
            res => res.json()
        ).then(
            json => {
                if (cancel) return;
                setcontent_state(json)
            }
        )

        return () => { 
            cancel = true;
        }
    }, [])

    const [content_state, setcontent_state] = useState({});

    const navigate = useNavigate();
    const location = useLocation();

    const [selectpage_updater, setselectpage_updater] = useState(0);
    const [subpagesShown, setsubpagesShown] = useState([]);
    const refsSubpages = useRef([]);

    useEffect(()=>{
        let sp = location.pathname.split("/")[2];
        if(!sp)
            sp = "Dashboard"
        window.sessionStorage.setItem("active_navigation_item", sp); 
        selectedPage(sp); 
        setselectpage_updater(selectpage_updater+1);
    }, [location])

    useEffect(()=>{
        //console.log(navigationData[userRole])
    }, [navigationData, userRole])

    const handleClickSubmenu = (e, i) =>{
        let tmp = [...subpagesShown];
        if(!tmp.includes(i)){
            tmp = tmp.concat(i);
        }
        else{
            tmp.splice(tmp.indexOf(i), 1);
            tmp = tmp.concat("ani"+i);

            const removeAnimation = () =>{
                let tmp = [...subpagesShown];
                tmp.splice(tmp.indexOf("ani"+i), 1);
                setsubpagesShown(tmp);
            }

            setTimeout(removeAnimation, 190);
        }
        setsubpagesShown(tmp);
    }

    const [navigationSwipeStatus, setnavigationSwipeStatus] = useState(true);
    const main_nav = useRef(null);
    const animateSwipeLeft = () =>{
        let header = main_nav.current.children[0];
        let buttons = main_nav.current.children[1];
        let footer = main_nav.current.children[2];

        if(navigationSwipeStatus){
            //console.log("close", main_nav);
            
            const hideContent = () =>{      
                //buttons.style.display = "none";
                //footer.style.display = "none";
            }

            const hideHeader = () =>{
                //header.children[0].children[0].style.display = "none";
            }
            
            setTimeout(hideHeader, 100);
            setTimeout(hideContent, 200);
        }
        else{
            //console.log("open");

            const showContent = () =>{
                //buttons.style.display = "block";
                //footer.style.display = "block";
            }

            const showHeader = () =>{      
                //header.children[0].style.display = "flex";
                //header.children[0].children[0].style.display = "block";
            }
            setTimeout(showHeader, 100);
            setTimeout(showContent, 200);
        }

        setnavigationSwipeStatus(!navigationSwipeStatus);
    }

    const animateSwipeUp = () =>{
        let header = main_nav.current.children[0];
        let buttons = main_nav.current.children[1];
        let footer = main_nav.current.children[2];

        if(navigationSwipeStatus){
            //console.log("close", main_nav);
            
            const hideContent = () =>{      
                main_nav.current.children[0].children[1].style.display = "none";
                //main_nav.current.children[1].children[1].children[0].style.display = "none";
                main_nav.current.children[1].children[0].style.display = "none";
                //buttons.style.display = "none";
                //footer.style.display = "none";
            }
            
            setTimeout(hideContent, 200);
        }
        else{
            //console.log("open");

            const showContent = () =>{
                main_nav.current.children[0].children[1].style.display = "block";
                //main_nav.current.children[1].children[1].children[0].style.display = "block";
                main_nav.current.children[1].children[0].style.display = "block";
                //buttons.style.display = "block";
                //footer.style.display = "block";
            }

            setTimeout(showContent, 200);
        }

        setnavigationSwipeStatus(!navigationSwipeStatus);
    }

    const handleClickNavButton = (v) =>{
        v = v.replace(/\s+/g, '-');

        const goToPage = () =>{
            // Qastan.addLog({
            //     "level":Qastan.level.Info,
            //     "type":Qastan.type.Navigation,
            //     "details": {
            //         "title": "Navigation",
            //         "description": "User went to " + v,
            //         "eventtype": "onnavigate",
            //     },
            //     "user": JSON.parse(window.sessionStorage.getItem("user_data")).id
            // })

            window.sessionStorage.setItem("active_navigation_item", v); 
            selectedPage(v); 
            setselectpage_updater(selectpage_updater+1);
            navigate(v);
            window.sessionStorage.setItem("page_files", null);
        }

        if(window.screen.width < 700){
            animateSwipeUp()
            setTimeout(goToPage, 200)
        }
        else{
            goToPage()
        }
    }

  return (
    <div className={navigationSwipeStatus ? styles.main_nav : styles.main_nav_ani} ref={main_nav} id={selectpage_updater}>
        <div>
            <div className={styles.nav_header}>
                <img onClick={()=>{(handleClickNavButton(Object.keys(navigationData[userRole])[0]))}} className={navigationSwipeStatus ? 'my-4 mx-5 h-10' : styles.nav_logo_ani} src={logo_wide} alt="logo"/>
                <button onClick={()=>{animateSwipeLeft()}} className={navigationSwipeStatus ? styles.swipe_navigation_button : styles.swipe_navigation_button_ani}><img src={arrow_white} alt="icon"/></button>
                <button onClick={()=>{animateSwipeUp()}} className={navigationSwipeStatus ? styles.close_navigation_button : styles.close_navigation_button_ani}><img src={arrow_gray} alt="icon"/></button>
            </div>
            <div className={navigationSwipeStatus ? styles.nav_buttons : styles.nav_buttons_ani}>
                {navigationData &&
                    (navigationData[userRole] &&
                    Object.keys(navigationData[userRole]).map((v, i)=>{
                        return (
                            <div key={i} className={styles.nav_button}>
                            {(navigationData[userRole] && ((typeof(navigationData[userRole][v]) === "boolean" && (navigationData[userRole][v] === true) && Object.keys(navigationData[userRole][v]) !== "") || ((navigationData[userRole][v][Object.keys(navigationData[userRole][v])[0]] && Object.keys(navigationData[userRole][v])[0] !== "")))) && 
                            <div className={window.sessionStorage.getItem("active_navigation_item") ? (window.sessionStorage.getItem("active_navigation_item").replace(/\W/g, '').toLocaleLowerCase() === v.replace(/\W/g, '').toLocaleLowerCase() ? styles.nav_maindivACTIVE : styles.nav_maindiv) : styles.nav_maindiv} onClick={()=>{handleClickNavButton(v);}}>
                                <button className={styles.nav_mainpage}>
                                {(typeof(navigationData[userRole][v]) === "boolean" && (navigationData[userRole][v] === true)) ? 
                                v
                                : 
                                (navigationData[userRole][v][Object.keys(navigationData[userRole][v])[0]] && 
                                Object.keys(navigationData[userRole][v])[0])}
                                </button>       
                                
                                {typeof(navigationData[userRole][v]) === "object" && 
                                (Object.keys(navigationData[userRole][v]).length > 1 && 
                                <button onClick={(e)=>{handleClickSubmenu(e, i)}} className={subpagesShown.includes(i) ? styles.nav_main_openmarkOPEN : styles.nav_main_openmark}><img src={arrow} alt="icon"/></button>
                                )}
                            </div>
                            }

                            {((typeof(navigationData[userRole][v]) !== "boolean" && subpagesShown.includes(i)) || (typeof(navigationData[userRole][v]) !== "boolean" && subpagesShown.includes("ani"+i))) &&
                            <>
                                <div className={!subpagesShown.includes("ani"+i) ? styles.nav_subpages : styles.nav_subpagesCLOSE} ref={(ref)=>{refsSubpages.current[i] = ref}}>   
                                    {Object.keys(navigationData[userRole][v]).map((val, ind)=>{
                                        if(Object.keys(navigationData[userRole][v])[0] !== val && navigationData[userRole][v][val]){
                                            return <button className={styles.nav_subpage} key={ind}>{val}</button>
                                        }
                                    })}
                                </div>
                            </>
                            }
                            </div>
                        )
                    }))
                }
            </div>
        </div>
        <div className={navigationSwipeStatus ? styles.nav_footer : styles.nav_footer_aniDown}>
            <Button value={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.navigation_logout && content_state[ReactSession.get("language")].General.navigation_logout) : "Log out"} onClick={()=>{loggedOut(true)}}/>
            <div className={styles.mobile_languagePicker}>
                <Dropdownlist value={lang_updater} 
                menuPlacement={"top"}
                isSearchable={false}
                data={[
                    (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                    (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                    (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                ]} 
                defaultValue type="language" onChange={(v)=>{handleChangeLanguage(v)}}/>
            </div>
        </div>
    </div>
  );
}